import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@pella/cosmos-react';
import { QUERY_KEYS } from '../../utils/enums';

/**
 * Hook to fetch cost centers filtered by division and location.
 * @param {string} division - The division code to filter by.
 * @param {string} location - The location code to filter by.
 * @returns {object} Cost centers query result with data, loading, success, and error states.
 */
export const useCostCenters = (division, location) => {
  const { api, apiReady } = useAPI();
  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: [QUERY_KEYS.INV_MGMT_COST_CENTERS, division, location],
    queryFn: () => api.invMgmt.getCostCenters({ division, location }),
    enabled: apiReady && Boolean(division) && Boolean(location),
    staleTime: Number.POSITIVE_INFINITY,
  });
  return {
    costCenters: data,
    costCentersIsLoading: isLoading,
    costCentersIsSuccess: isSuccess,
    costCentersIsError: isError,
    costCentersError: error,
  };
};
